module.exports = __webpack_public_path__ + "img/statistics.6f268c08.png";